import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c84f1fe2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M3.87859 9.26383L9.46894 3.53424C10.2987 2.65364 11.5274 2.30048 12.6828 2.61049C13.8383 2.92049 14.7406 3.84543 15.043 5.02979C15.3277 6.14449 15.0392 7.32572 14.2933 8.16461L14.1481 8.31779L8.52452 14.0853C7.77804 14.8246 6.5913 14.8142 5.85724 14.062C5.15813 13.3456 5.11532 12.2081 5.74089 11.4348L5.83974 11.3216L11.4577 5.56098C11.6532 5.36051 11.9703 5.36045 12.1659 5.56086C12.3397 5.739 12.3591 6.01556 12.2239 6.21562L12.166 6.28671L6.55407 12.0409C6.21256 12.4035 6.21753 12.9797 6.56525 13.336C6.88621 13.6649 7.38989 13.6944 7.73867 13.4265L7.82245 13.3534L13.4461 7.58579C14.0449 6.99301 14.285 6.11519 14.0742 5.28973C13.8634 4.46426 13.2345 3.81961 12.4292 3.60354C11.6815 3.40291 10.8896 3.60082 10.3124 4.12663L10.1831 4.25376L4.58669 9.98971C3.13967 11.473 3.13968 13.8778 4.58671 15.361C5.98705 16.7965 8.22938 16.8428 9.68403 15.5L9.8268 15.3611L16.6452 8.37129C16.8407 8.17085 17.1578 8.17083 17.3533 8.37126C17.5272 8.54942 17.5465 8.82599 17.4113 9.02603L17.3534 9.09711L10.5349 16.0869C8.69684 17.971 5.71669 17.971 3.87858 16.0869C2.09153 14.2551 2.04189 11.3168 3.72967 9.42351L3.87859 9.26383Z",
    fill: "#606B85"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["FilesInput", { 'FilesInput--disabled': _ctx.disabled }])
  }, [
    _createElementVNode("input", {
      type: "file",
      hidden: "",
      disabled: _ctx.disabled,
      accept: "*",
      multiple: "",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onUpdate && _ctx.onUpdate(...args)))
    }, null, 40, _hoisted_1),
    _hoisted_2
  ], 2))
}